import React from "react";
import locationIcon from "../../../images/location-icon.svg";

interface MarketLeader {
  id: number;
  location: string;
  count: number;
}

interface MarketLeadersProps {
  data: MarketLeader[];
}

const MarketLeaders: React.FC<MarketLeadersProps> = ({ data }) => {
  return (
    <div className="chart-container market-leaders">
      <div className="chart-header">
        <div>
          <h3>Market Leaders</h3>
          <p>Trending the current region-doors by region</p>
        </div>

      </div>
      <div className="market-leaders-list">
        {data.map((leader, index) => (
          <div key={leader.id} className="market-leader-item">
            <div className="leader-location">
              <img src={locationIcon} alt="location" className="location-icon" />
              <span className="location-name">{leader.location}</span>
            </div>
            <span className="leader-count">{leader.count}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MarketLeaders;
